import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue"
import { useSalesBotStore } from '@/store/modules/salesBot'
import router from "@/router";
import { useRoute } from 'vue-router/composables'
import { useGoogleAnalytics, Event } from "@/composables/useGoogleAnalytics";
import { useAuth0 } from "@/composables/useAuth0";
import auth from "@/store/modules/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotToBookingButton',
  props: {
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const route = useRoute()
const salesBotStore = useSalesBotStore()
const { hasSpecialScenario } = salesBotStore

const { quoteId: previousQuoteExternalId } = route?.params
const loading = ref(false)

async function onClick() {
  try {
    loading.value = true
    const quoteId = await salesBotStore.saveQuote(previousQuoteExternalId || null)
    trackCreateQuote(quoteId)

    if (hasSpecialScenario) {
      await router.push({
        name: 'quote-index',
        query: { quoteId: quoteId.toString() }
      })
    } else {
      await router.push({
        name: 'checkout-single-bid',
        params: { quoteId: quoteId.toString() }
      })
    }
  } catch(e) {
    console.error(e)
  }
  loading.value = false
}

// GA4 TRACKING
const analytics = useGoogleAnalytics()
const auth0 = useAuth0()

function trackCreateQuote(quoteId: number): void {
  const isLoggedIn = !!auth.isTokenSet && !!auth.userId
  const hasBookedBefore = auth?.customer?.convertedQuoteCount > 0

  analytics.trackEvent(Event.QuoteCreate, {
    isAuth0: auth0.isInitialized,
    hasBookedBefore,
    isLoggedIn,
    quoteId: quoteId || null
  })
}


return { __sfc: true,props, route, salesBotStore, hasSpecialScenario, previousQuoteExternalId, loading, onClick, analytics, auth0, trackCreateQuote }
}

})